module.exports = __webpack_public_path__ + "static/interior_on_left_s-a4b66a66dc06055bda2f584973c4a33b.webp";